import globe from "./world.webp";
import airplane from "./airplane.webp";

type OnflyLoadingProps = {
  containerSize?: number
};

export const OnflyLoading = ({ containerSize = 100 }: OnflyLoadingProps) => {

  return (
    <div
      style={{
        position: "relative",
        width: `${containerSize}px`,
        height: `${containerSize}px`,
      }}
    >
      <img
        src={globe}
        alt="Globe"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          width: "70%",
          height: "70%",
          transform: "translate(-50%, -50%)",
          zIndex: 1,
        }}
      />

      <img
        src={airplane}
        alt="Airplane spin"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          animation: "spin 4s linear infinite",
          transformOrigin: "center center",
          zIndex: 2,
        }}
      />

      <style>
        {`
          @keyframes spin {
            from { transform: translate(-50%, -50%) rotate(0deg); }
            to { transform: translate(-50%, -50%) rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};
